componentRegistryInstance.register('file', 'edit', 'hrd.components.form.FileComponent');

hrd.components.form.FileComponent = hrd.components.AbstractFieldComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.FileComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},

	enhanceEditField: function(field, id, klass) {
		this._super(field, id, klass);
		let fileInfo;
		let reference = this.settings.reference;
		let formInstance = this.getFormInstance();
		if (field.data('info') != undefined) {
			fileInfo = $.evaluate(field.data('info'), formInstance);
		} else {
			let fileInfoFn = $.functionCase(field.data('name') + '-file-info');
			if (reference && typeof reference[fileInfoFn] == 'function') {
				fileInfo = reference[fileInfoFn].call(reference, field, formInstance);
			} else {
				console.log(`function "${fileInfoFn}" not available in proper object reference "${reference._FULL_}". Add it or use "data-info" attribute`);
			}
		}
		if (fileInfo != undefined) {
			field.data('fileInfo', fileInfo);
			// only in this case something can be done
			var $composite = field.closest('.field-composite');
			field.prop('type', 'file'); // force to be an input file

			fileInfo.isMultiple = field.attr('multiple') == 'multiple';

			fileInfo.toggleAttachmentsContainerFn = $.noop;
			fileInfo.appendAttachmentElementFn = $.noop;
			fileInfo.appendAttachmentStubFn = $.noop;
			fileInfo.enhanceFileObjectFn = $.noop;
			fileInfo.clearAttachmentsContainerFn = $.noop;

			if (fileInfo.showAttachments) {

				var $attachmentsZone = $('<div class="attachments-zone ignore-for-fhs"></div>').appendTo($composite).hide();
				if (fileInfo.attachmentsZoneClass != undefined) {
					$attachmentsZone.addClass(fileInfo.attachmentsZoneClass);
				}
				if (fileInfo.attachmentsZoneStyle != undefined) {
					$attachmentsZone.css(fileInfo.attachmentsZoneStyle);
				}
				fileInfo.clearAttachmentsContainerFn = () => {
					$attachmentsZone.empty();
				};

				fileInfo.toggleAttachmentsContainerFn = () => {
					var hasChildren = $attachmentsZone.children('.attachment-container').exists();
					$attachmentsZone.toggle(hasChildren);
				};

				/**
				 * La Funzione Custom può cercare di popolare le seguenti proprietà: attachment, attachmentName, deleteFn, style, icon
				 */
				fileInfo.enhanceFileObjectFn = (file, id) => {
					file.icon = 'f-icon fas fa-file';
					let enhanceCustomName = ((id.indexOf('ui-id') == 0) ? field.data('name') : id) + '-enhance-file-object';
					enhanceCustomName = $.functionCase(enhanceCustomName);

					if (reference && typeof reference[enhanceCustomName] === 'function') {
						// fix: use 'this.settings.inputData' instead of 'toObject()' because is called during 'toForm'
						let inputData = this.getFormInstanceSetting('inputData');
						var extraEnhancements = reference[enhanceCustomName].call(reference, file, inputData, formInstance, fileInfo);
						if (extraEnhancements != undefined) {
							file = $.extend(true, file, extraEnhancements);
						}
					} else {
						if (fileInfo.customizeFileObjectEnhancement == undefined || fileInfo.customizeFileObjectEnhancement == true) {
							console.log(`function "${enhanceCustomName}" not available in proper object reference "${reference._FULL_}". Add it or use "customizeFileObjectEnhancement=false" in configuration`);
						}
					}

					file.getContainerElement = () => $(`#${id}`);

					var attachmentInfo = file.attachment || file[fileInfo.attachmentsProperty];

					if (attachmentInfo) {
						if (file.attachmentName == undefined && attachmentInfo.name != undefined) {
							file.attachmentName = attachmentInfo.name;
						}
						file.toDownloadUri = () => hrd.fn.actionURI('download') + '?uid=' + attachmentInfo.uid;
					}

					if (file.deleteFn) {
						file.deleteFile = file.deleteFn;
					}
					return file;
				};

				fileInfo.appendAttachmentStubFn = (file) => {
					var $container = $('<span class="attachment-container"></span>').uniqueId();
				
					if(field.usingChromaFlow()) {
						$container = $(`
							<div class="attachment-container field-composite label-on-top">
							</div>
						`).uniqueId();
					}
				
					file.containerId = $container.attr('id');
					$attachmentsZone.append($container);

					// PROGRESS BAR
					var $progress = $('<span class="progress-attachment"><span class="progress-attachment-bar"></span></span>');

					//DOWNLOAD BUTTON
					var $button = $('<button class="dashlet-button download-attachment"></button>').text(file.name);
					$button.button({
						icons: {
							primary: 'f-icon fas fa-file'
						},
						text: false
					});

					//APPEND BUTTONs to the CONTAINER
					$container.append($progress).append($button);
				};

				fileInfo.appendAttachmentElementFn = (file, fileData) => {
					var $container;
					if (fileData && fileData.containerId) {
						// retrieve previous container and empty it
						$container = $('#' + fileData.containerId);
						$container.empty();
					} else {
						$container = $('<span class="attachment-container"></span>').uniqueId();
					
						if(field.usingChromaFlow()) {
							$container = $(`
								<div class="attachment-container field-composite label-on-top">
									<label class="ui-helper-hidden-important"></label>
								</div>
							`).uniqueId();	
						}
					
						$attachmentsZone.append($container);
					}
					file = fileInfo.enhanceFileObjectFn(file, $container.attr('id'));

					//DOWNLOAD BUTTON
					var $button = $('<button class="dashlet-button download-attachment"></button>').text(file.attachmentName);
					if (file.style) {
						$button.addClass(file.style);
					}
					$button
						.button({
							icons: {
								primary: file.icon
							},
							text: !!fileInfo.showAttachmentsText
						})
						.off('.db')
						.on('click.db', () => {
							if (typeof file.toDownloadUri === 'function') {
								var attachmentInfo = file.attachment || file[fileInfo.attachmentsProperty];
								if (attachmentInfo && attachmentInfo.contentType && attachmentInfo.contentType.indexOf('image/') != -1) {
									var df = new hrd.HtmlDialogFactory({
										title: file.attachmentName,
										width: '800',
										cssClass: 'image-viewer'
									});
									df.getFormFactory()
										.addFieldset(1)
										.addReadField('image', { type: 'image', tag: 'img', 'width': 4095, 'parentHeight': 600 });
									df.open({ image: attachmentInfo }, {
										showOkButton: false,
										showCancelButton: false,
										closeOnOverlay: true,
										destroyOnClose: true
									});
								} else {
									window.open(file.toDownloadUri(), '_blank');
								}
							}
						})
						.attr('title', file.attachmentName)
						.tooltip();
						
					if(field.usingChromaFlow()) {
						$container.append('<label class="ui-helper-hidden-important"></label><div></div>');
						$container.append($button);
					} else {
						$container.append($button);
					}

					//DELETE BUTTON
					if (typeof file.deleteFileFn === 'function') {
						var $delete = $(`<button class="delete-attachment" data-variants="${fileInfo.deleteAttachmentVariants || ''}"></button>`)
							.text(xlate('common.deleteAttachment.tooltip.msg'))
							.button({
								icons: {
									primary: `f-icon ${fileInfo.deleteAttachmentIcon || "fas fa-times"}`
								},
								text: false
							})
							.off('.db')
							.on('click.db', () => {
								hrd.dashboard.msgBox({
									title: xlate('common.dialog.warning.title.msg'),
									text: xlate('common.deleteAttachment.title.msg')
								})
									.then(() => file.deleteFileFn())
									.then(() => {
										let fData;
										if (fileInfo.updateFormObject) {
											fData = this.formInstanceToObject();
											this.setValueByPath(fData, fileInfo.attachmentsProperty, undefined);
										}
										if (typeof fileInfo.onFileDeleted === 'function') {
											fData = fData || this.formInstanceToObject();
											fileInfo.onFileDeleted.call(reference, fData, formInstance);
										}
										file.getContainerElement().remove();
										fileInfo.toggleAttachmentsContainerFn();
									});
							})
							.tooltip();
						
						if(field.usingChromaFlow()) {
							$container.append($delete);
						} else {
							$container.append($delete);
						}
					}
				};

			}

			if (fileInfo.droppable) {
				// needed to disable standard behaviour of DD
				$(document).on('drop dragover', function(event) {
					event.preventDefault();
				});
				field.hide();

				// prepare dropZONE
				var $dropZone = $(`<div class="dropzone"><i class="f-icon fas fa-cloud-upload-alt fa-4x"></i></div>`);
				if (fileInfo.dragMessage) {
					$dropZone.append(`<div>${fileInfo.dragMessage}</div>`)
				}
				if (fileInfo.dropZoneAfterLabel) {
					field.before($dropZone);
				} else {
					$composite.prepend($dropZone);
				}
				if (fileInfo.dropZoneClass != undefined) {
					$dropZone.addClass(fileInfo.dropZoneClass);
				}
				if (fileInfo.dropZoneStyle != undefined) {
					$dropZone.css(fileInfo.dropZoneStyle);
				}
				$dropZone
					.on('click', (_) => {
						field.trigger('click');
					})
					.on('dragover', (event) => {
						$(event.currentTarget).addClass('dropzone-hover');
					})
					.on('dragleave', (event) => {
						$(event.currentTarget).removeClass('dropzone-hover');
					});

				if(field.usingChromaFlow()) {
					$composite.addClass('label-on-top');

					$.timeout(0)
						.then(() => {
							const $downloadButton = $('.download-attachment', $composite);
							const $deleteButton = $('.delete-attachment', $composite);

							$downloadButton.addClass('button-with-addon');
							$deleteButton.attr('data-variants', 'addon');
							this.wrapForGenericAddon($downloadButton);
							$downloadButton.removeClass('ui-button-icon-only');
						});
				}
			}

			// configure 'fileupload' plugin
			let url;
			let usingJsonProvider = false;
			if (fileInfo.provider != undefined && fileInfo.method != undefined) {
				url = `${hrd.globals.jsondataURI}?_=${fileInfo.provider.substring(fileInfo.provider.lastIndexOf('.') + 1)}.${fileInfo.method}`;
				usingJsonProvider = true
			} else if (fileInfo.action != undefined) {
				url = hrd.fn.actionURI(fileInfo.action);
			} else {
				hrd.dashboard.errorDialog('File Upload must have "provider" and "method" fields or the "action" field');
				return;
			}
			// preparazione di callbacks
			let prefix = (id.indexOf('ui-id') == 0) ? field.data('name') : id;

			let sAcceptableFn = $.functionCase(`${prefix}-accettable-file`);
			let acceptableFn;
			if (reference && typeof reference[sAcceptableFn] === 'function') {
				acceptableFn = reference[sAcceptableFn];
			} else {
				if (fileInfo.customizeAcceptables == undefined || fileInfo.customizeAcceptables == true) {
					console.log(`function "${sAcceptableFn}" not available in proper object reference "${reference._FULL_}". Add it or use "customizeAcceptables: false" in configuration`);
				}
				acceptableFn = () => $.when(true);
			}

			let sUploadCompletedFn = $.functionCase(`${prefix}-upload-completed`);
			let uploadCompletedFn;
			if (reference && typeof reference[sUploadCompletedFn] == 'function') {
				uploadCompletedFn = reference[sUploadCompletedFn];
			} else {
				if (fileInfo.onUploadCompleted == undefined || fileInfo.onUploadCompleted == true) {
					console.log(`function "${sUploadCompletedFn}" not available in proper object reference "${reference._FULL_}". Add it or use "onUploadCompleted: false" in configuration`);
				}
				uploadCompletedFn = $.noop;
			}

			/* add maxSizeBuilder as utility method */
			fileInfo.maxSizeBuilder = (size, unit) => {
				unit = unit || 'MB';
				let power = (unit === 'GB') ? 3 : (unit === 'MB') ? 2 : 1;
				return {
					maxSize: size,
					sizeUnit: unit,
					maxFileSizeInBytes: size * Math.pow(1024, power)
				};
			};

			//
			let sValidatateFn = $.functionCase(`${prefix}-upload-validation`);
			let validatateFn;
			if (reference && typeof reference[sValidatateFn] === 'function') {
				validatateFn = reference[sValidatateFn];
				// because a validation will be performed, size data can be prepared
				let sizeUnit = hrd.utils.get('globals.prefs.fileUploadSizeUnit', hrd, 'MB');
				let maxSize = hrd.utils.get('globals.prefs.fileUploadMaxSize', hrd, 2);
				fileInfo.maxSizeValidationInfo = fileInfo.maxSizeBuilder(maxSize, sizeUnit);
			} else {
				if (fileInfo.customizeValidation === true) {
					console.log(`function "${sValidatateFn}" not available in proper object reference "${reference._FULL_}". Add it or remove "customizeValidation: true" in configuration`);
				}
				validatateFn = () => ({}); // empty configuration
			}

			var options = {
				dataType: 'json',
				dropZone: ($dropZone == undefined) ? null : $dropZone,
				url: url,
				singleFileUploads: true,
				sequentialUploads: false,
				replaceFileInput: false,
				beforeSend: (xhr, _) => {
					if (hrd.globals.apiKey != undefined) {
						xhr.setRequestHeader("Api-Key", hrd.globals.apiKey);
					}
					if (hrd.globals.apiKeyExt != undefined) {
						xhr.setRequestHeader("Api-Key-Ext", hrd.globals.apiKeyExt);
					}
					if (hrd.globals.apiKeyUser != undefined) {
						xhr.setRequestHeader("Api-Key-User", hrd.globals.apiKeyUser);
					}
				},
				send: (_, data) => {
					if (!fileInfo.isMultiple) {
						// clear attachment zone before adding new one
						fileInfo.clearAttachmentsContainerFn();
					}

					if (fileInfo.showSpinner) {
						$dropZone.waiting();
					}

					fileInfo.appendAttachmentStubFn(data.files[0]);
					fileInfo.toggleAttachmentsContainerFn();
				},
				progress: (_, data) => {
					var file = data.files[0];
					var $container = $('#' + file.containerId);
					$('.progress-attachment-bar', $container).css('width', `${parseInt(data.loaded / data.total * 100, 10)}%`);
				},
				done: (evt, data) => {
					var file = data.result;
					var fileData = data.files[0];
					$.when(acceptableFn.call(reference, file))
						.then((acceptable) => {
							if (acceptable) {
								var obj = {};
								var gvbp;
								if (fileInfo.attachmentsProperty != undefined) {
									gvbp = this.getValueByPath(file, fileInfo.attachmentsProperty);
									if (gvbp == undefined) {
										this.setValueByPath(obj, fileInfo.attachmentsProperty, $.extend(true, {}, file));
									} else {
										obj = $.extend(true, {}, file);
									}
								}
								fileInfo.appendAttachmentElementFn(obj, fileData);
								fileInfo.toggleAttachmentsContainerFn();
								var formData;
								if (fileInfo.updateFormObject) {
									formData = this.formInstanceToObject();
									if (fileInfo.attachmentsProperty != undefined) {
										this.setValueByPath(formData, fileInfo.attachmentsProperty, gvbp);
									}
									if (fileInfo.updateFormExtraField) {
										fileInfo.updateFormExtraFieldTarget = fileInfo.updateFormExtraFieldTarget || fileInfo.updateFormExtraField;
										if ($.isArray(fileInfo.updateFormExtraField)) {
											fileInfo.updateFormExtraField.forEach((item, index) => this.setValueByPath(formData, fileInfo.updateFormExtraFieldTarget[index], file[item]));
										} else {
											this.setValueByPath(formData, fileInfo.updateFormExtraFieldTarget, file[fileInfo.updateFormExtraField]);
										}
									}
								}

								if ($dropZone) {
									$dropZone.waiting('done');
								}

								/* once uploaded, the file input can be cleared */
								const target = evt.target;
								target.value = ''; // needed to clear the file input box
								/* */

								uploadCompletedFn.call(reference, formData, formInstance, fileInfo, file);
							} else {
								// remove stub
								$(`#${fileData.containerId}`).remove();
							}
						});

					if ($dropZone) {
						$dropZone.removeClass('dropzone-hover');
					}
				}
			};

			/* extends with validation options (to-be completed)*/
			options = $.extend(options, validatateFn.call(reference, fileInfo));

			if (typeof options.customValidation === 'function') {
				let origFn = options.customValidation;
				options.customValidation = (data, opts) => origFn.call(reference, data, opts);
			}

			field.fileupload(options)
				.on('fileuploadadd', (_, data) => {
					var formData = {};
					if (usingJsonProvider) {
						formData.impl = fileInfo.provider;
						formData.method = fileInfo.method;
					}

					var formDataName = ((id.indexOf('ui-id') == 0) ? field.data('name') : id) + '-form-data';
					formDataName = $.functionCase(formDataName);
					if (reference && typeof reference[formDataName] === 'function') {
						var extra = reference[formDataName].call(reference, field, this.formInstanceToObject(), formInstance);
						if (extra != undefined) {
							formData = $.extend(formData, extra);
						}
					} else {
						console.log(`function "${formDataName}" not available in proper object reference "${reference._FULL_}"`);
					}

					// really takes only on file
					$.each(data.files, (index, file) => {
						formData.name = file.name;
						formData.size = file.size;
						formData.type = file.type;
					});
					data.formData = formData;
				})
				.on('fileuploadprocessalways', (evt, data) => {
					var currentFile = data.files[data.index];
					if (data.files.error && currentFile.error) {
						/* detect if K,M,G */
						let unitSize, divisor;
						if (options.maxFileSize < Math.pow(1024, 2)) {
							unitSize = 'KB';
							divisor = Math.pow(1024, 1);
						} else if (options.maxFileSize > Math.pow(1024, 3)) {
							unitSize = 'GB';
							divisor = Math.pow(1024, 3);
						} else {
							unitSize = 'MB';
							divisor = Math.pow(1024, 2);
						}

						let msgText = `
							<h4>${currentFile.error}:</h4>
							<ul>
								<li><b>${xlate('common.validation.file.fileName.msg')}</b>: ${currentFile.name}</li>
								<li><b>${xlate('common.validation.file.fileType.msg')}</b>: ${currentFile.type}</li>
								<li><b>${xlate('common.validation.file.fileSize.msg')}</b>: ${(currentFile.size / (divisor)).toFixed(2)} ${unitSize}</li>
							</ul>
						`;
						// there was an error, do something about it
						hrd.dashboard.msgBox({
							title: xlate('common.dialog.warning.title.msg'),
							text: msgText,
							type: 'OK',
							okLabel: xlate('common.dialog.close.btn'),
							size: '2x',
							width: 620
						});

						const target = evt.target;
						target.value = ''; // needed to clear the file input box
						data.abort(); //aborting submission
					}
				});

			if (fileInfo.appearance === 'button') {
				const buttonText = fileInfo.buttonText;
				const buttonIcon = fileInfo.buttonIcon;
				const buttonTooltip = fileInfo.buttonTooltip;
				const buttonVariants = fileInfo.buttonVariants || '';
				const $button = $(`<button data-variants="${buttonVariants}">${buttonText}</button>`);

				$button
					.off('.upload')
					.on('click.upload', () => field.trigger('click'))
					.button();

				$button.button('option', 'text', !!buttonText);

				if(buttonIcon) {
					$button.button('option', 'icons', { primary: `f-icon ${buttonIcon}` });
				}

				field.hide();
				field.before($button);

				if(buttonTooltip) {
					$button
						.attr('title', buttonTooltip)
						.tooltip();
				}
			}
		}
	},

	getEditableField: function(field, name, object, options) {
		// do nothing: do not call 'super'
	},

	setEditableField: function(field, value, object, options) {
		// prefill attachments if available and showable
		var fileInfo = field.data('fileInfo');
		if (fileInfo && fileInfo.showAttachments && fileInfo.attachmentsProperty) {
			var attachments = this.getValueByPath(object, fileInfo.attachmentsProperty);
			if ($.isArray(attachments) || $.isPlainObject(attachments)) {
				if (!$.isArray(attachments)) {
					attachments = [attachments];
				}
				if (attachments.length > 0) {
					var $composite = field.closest('.field-composite');
					var $attachmentsZone = $('.attachments-zone', $composite);
					$attachmentsZone.empty(); // empty previous attachments before adding new ones
					$.each(attachments, (i, file) => {
						var obj = {};
						this.setValueByPath(obj, fileInfo.attachmentsProperty, $.extend(true, {}, file));
						fileInfo.appendAttachmentElementFn(obj);

					});
					fileInfo.toggleAttachmentsContainerFn();
				}
			}
		}
	},
	resetEditableField: function(field, options) {
		// reset attachments if showable
		let fileInfo = field.data('fileInfo');
		if (fileInfo && fileInfo.showAttachments) {
			var $composite = field.closest('.field-composite');
			var $attachmentsZone = $('.attachments-zone', $composite);
			$attachmentsZone.empty(); // empty attachments
			fileInfo.toggleAttachmentsContainerFn();
		}
	},
});